import PropTypes from "prop-types";
import React from "react";

import ModuleCompaniesListing from "./module-companies-listing.jsx";
import ModuleEmbed from "./module-embed.jsx";
import ModuleEventListing from "./module-event-listing.jsx";
import ModuleExternalLinks from "./module-external-links.jsx";
import ModuleFundCards from "./module-fund-cards.jsx";
import ModuleHeroQuoteAndImage from "./module-hero-quote-and-image.jsx";
import ModuleLandscapeMedia from "./module-landscape-media.jsx";
import ModuleMedia from "./module-media.jsx";
import ModuleNavigationStatement from "./module-navigation-statement.jsx";
import ModuleNewsCarousel from "./module-news-carousel.jsx";
import ModuleOrganisationListing from "./module-organisation-listing.jsx";
import ModulePeopleCarousel from "./module-people-carousel.jsx";
import ModulePullQuote from "./module-pullquote.jsx";
import ModuleText from "./module-text.jsx";

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

const ModuleDispatcher = (props) => {
    const editorialPageTypes = [
        "ContentPage",
        "NewsPage",
        "EventPage",
        "CompanyPage",
        "FundPage",
        "PersonPage",
        "Home",
    ];
    const editorialPage = editorialPageTypes.includes(props.pageTypename);
    const isFundPage = props.pageTypename === "FundPage";
    if (isFundPage) console.log("props", props);

    const noBackgroundModules = [
        "HeroQuoteAndImage",
        "CompaniesListing",
        "PeopleCarousel",
    ];
    const backgroundModules = [
        "ExternalLinks",
        "Text",
        "Pullquote",
        "Media",
        "NewsCarousel",
        "EventListing",
        "Embed",
    ];

    // Manage backgroundModules spacing and rounded corners
    let borderTop =
        editorialPage &&
        backgroundModules.includes(props.__typename) &&
        noBackgroundModules.includes(props.previousModuleType);
    let borderBottom =
        editorialPage &&
        backgroundModules.includes(props.__typename) &&
        (props.isLast === true ||
            noBackgroundModules.includes(props.nextModuleType) ||
            props.nextModuleType === "NavigationStatement");

    // Manage spacing between noBackgroundModules
    if (noBackgroundModules.includes(props.__typename)) {
        borderTop = true;
        borderBottom =
            props.isLast === true ||
            backgroundModules.includes(props.nextModuleType);
    }

    if (props) {
        switch (props.__typename) {
            case "CompaniesListing":
            case "AirtableSyncedCompaniesListing":
                return (
                    <div className="module module-companies-listing">
                        <ModuleCompaniesListing
                            borderBottom={borderBottom}
                            borderTop={borderTop}
                            {...props}
                        />
                    </div>
                );
            case "Embed":
                return (
                    <div className="module module-embed">
                        <ModuleEmbed
                            borderBottom={borderBottom}
                            borderTop={borderTop}
                            {...props}
                        />
                    </div>
                );
            case "EventListing":
                return (
                    <div className="module module-event-listing">
                        <ModuleEventListing
                            borderBottom={borderBottom}
                            borderTop={borderTop}
                            {...props}
                        />
                    </div>
                );
            case "ExternalLinks":
                return (
                    <div className="module module-external-links">
                        <ModuleExternalLinks
                            borderBottom={borderBottom}
                            borderTop={borderTop}
                            {...props}
                        />
                    </div>
                );
            case "FundCards":
                return (
                    <div className="module module-fund-cards">
                        <ModuleFundCards
                            borderBottom={borderBottom}
                            borderTop={borderTop}
                            {...props}
                        />
                    </div>
                );
            case "HeroQuoteAndImage":
                return (
                    <div className="module module-hero-quote-and-image">
                        <ModuleHeroQuoteAndImage {...props} />
                    </div>
                );
            case "LandscapeMedia":
                return (
                    <div className="module module-landscape-media">
                        <ModuleLandscapeMedia {...props} />
                    </div>
                );
            case "Media":
                return (
                    <div className="module module-media">
                        <ModuleMedia
                            borderBottom={borderBottom}
                            borderTop={borderTop}
                            isInModal={props.isInModal}
                            {...props}
                        />
                    </div>
                );
            case "NavigationStatement":
                return (
                    <div className="module module-navigation-statement">
                        <ModuleNavigationStatement
                            nextModuleType={props.nextModuleType}
                            pageType={editorialPage ? "editorial" : "landing"}
                            previousModuleType={props.previousModuleType}
                            {...props}
                        />
                    </div>
                );
            case "NewsCarousel":
                return (
                    <div className="module module-news-carousel">
                        <ModuleNewsCarousel
                            borderBottom={borderBottom}
                            borderTop={borderTop}
                            {...props}
                        />
                    </div>
                );

            case "OrganisationListing":
                return (
                    <div className="module module-organisation-listing">
                        <ModuleOrganisationListing
                            borderBottom={borderBottom}
                            borderTop={borderTop}
                            {...props}
                        />
                    </div>
                );
            case "PeopleCarousel":
            case "AirtableSyncedPeopleCarousel":
                return (
                    <div className="module module-people-carousel">
                        <ModulePeopleCarousel
                            borderBottom={borderBottom}
                            borderTop={borderTop}
                            {...props}
                        />
                    </div>
                );
            case "Pullquote":
                return (
                    <div className="module module-pullquote">
                        <ModulePullQuote
                            borderBottom={borderBottom}
                            borderTop={borderTop}
                            isInModal={props.isInModal}
                            {...props}
                        />
                    </div>
                );
            case "Text":
                return (
                    <div className="module module-text">
                        <ModuleText
                            borderBottom={borderBottom}
                            borderTop={borderTop}
                            isInModal={props.isInModal}
                            transparentBackground={isFundPage}
                            {...props}
                        />
                    </div>
                );
            default:
                return null;
        }
    } else {
        return null;
    }
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

ModuleDispatcher.propTypes = {
    __typename: PropTypes.string.isRequired,
    isLast: PropTypes.bool,
    isInModal: PropTypes.bool,
    nextModuleType: PropTypes.string,
    pageTypename: PropTypes.string.isRequired,
    previousModuleType: PropTypes.string,
};

export default ModuleDispatcher;
